import type { BootstrapVariables } from '../../../common/constants/relay/types';

// Gets the variables for the bootstrap state.
export const getBootstrapVariables = (b: BootstrapVariables): BootstrapVariables => {
	return {
		cloudId: b.cloudId,
		primaryProduct: b.primaryProduct,
		primarySubProduct: b.primarySubProduct,
		searchSessionId: b.searchSessionId,
		isRovoEnabled: b.isRovoEnabled,
		allFilterExcludedProducts: b.allFilterExcludedProducts,
		thirdPartyConfigs: b.thirdPartyConfigs,
		experimentConfig: b.experimentConfig,
		experimentLayers: b.experimentLayers,
		products: b.products,
		isJiraIssueIndexed: b.isJiraIssueIndexed,
		user: b.user,
		nouns: b.nouns,
		referrer: b.referrer,
		productDataRegions: b.productDataRegions,
		productEdition: b.productEdition,
		overrides: b.overrides,
	};
};
